if (typeof globalThis === 'undefined' && typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.globalThis = window;
}

export {};
